'use strict';
const Mn = require('backbone.marionette');
const i18n = require('i18next');
const ActionRepository = require('process/domain/repository/action/index');
const Action = require('process/domain/entity/action');
const ActionCreateView = require('process/ui/view/action/setting');
const NavWidthChanger = require('balus/ui/view/nav-width-changer');
const DataContentSelectorView = require('balus/ui/view/modal/data-content-selector');
const ActionListView = require('process/ui/view/action/list');
const ActionImportService = require('balus/app/service/action/import');
const Template = require('balus/ui/template/body/process/nav/index.hbs');
const ModalView = require('common/ui/view/modal/index');
const Router = require('balus/app/router/index');
const ProcessPermission = require('process/domain/entity/permission');

const ImportActionTemplateFilePath = require('file-loader?name=process/[name].[ext]!process/import-actions.xls');


module.exports = Mn.View.extend({
    editMode: false,
    template: Template,
    regions: {
        actionList: '.action-list-wrapper',
        widthChanger: '#nav-width-changer-wrapper',
        importFileSelector: '.import-file-selector'
    },
    ui: {
        relateButton: '.nav-relate',
        sortButton: '.nav-sort',
        doneButton: '.nav-done',
        actionAddButton: '.action-add-button',
        actionImportButton: '.nav-action-import'
    },
    events: {
        'click @ui.relateButton': 'startRelateMode',
        'click @ui.sortButton': 'startSortMode',
        'click @ui.doneButton': 'endEditMode',
        'click @ui.actionAddButton': 'addAction',
        'click @ui.actionImportButton': 'showImportAction'
    },

    templateContext: function() {
        const context = this.getOption('context');
        return {
            isEditable: context.getProjectRole().getPermission(
                ProcessPermission.ActionCreatePermission
            ).isPermitted(context),
            isImportable: context.getProjectRole().getPermission(
                ProcessPermission.ActionBulkImportPermission
            ).isPermitted(context),
            isEditing: this.getOption('edit'),
            isRelateMode: this.getOption('relateMode')
        };
    },

    onRender: function() {
        this.showChildView('widthChanger', new NavWidthChanger());

        let action;

        ActionRepository.find(this.model).get(this.model.getActionID())
            .then(_action => {
                action = _action;
                return action.getChildrenRecursive();
            })
            .then(children => {
                this.showChildView('actionList', new ActionListView({
                    model: action,
                    collection: children,
                    context: this.getOption('context'),
                    user: this.getOption('context').getUser(),
                    group: this.getOption('context').getGroup(),
                    viewState: this.getOption('viewState'),
                    relateMode: this.getOption('relateMode'),
                    sortMode: this.getOption('sortMode'),
                    smartScrollEnabled: true,
                }));
            });

        this.showChildView('importFileSelector', new DataContentSelectorView({
            project: this.model,
            hideURLInput: true,
            accept: ['xls'],
            title: i18n.t('balus_template_body_process:nav.import-action'),
            messagePanelContent: i18n.t(
                'balus_template_body_process:nav.import-action-sample-download',
                {url: `${ImportActionTemplateFilePath}?t=${(new Date()).getTime()}`})
        }));
        this.listenTo(this.getChildView('importFileSelector'), 'select', function(content) {
            this.importAction(content);
        });
    },

    startRelateMode: function() {
        this.relateMode = true;
        this.edit = true;
        this.render();
    },

    startSortMode: function() {
        this.sortMode = true;
        this.edit = true;
        this.render();
    },

    endEditMode: function() {
        this.relateMode = false;
        this.sortMode = false;
        this.edit = false;
        this.render();
    },

    addAction: function() {
        const context = this.getOption('context');
        const project = this.model;

        const actionId = this.model.getActionID();
        ActionRepository.find(this.model).get(actionId)
            .then(action => {
                const modal = new ModalView({
                    model: this.model,
                    title: i18n.t('process:action-setting.create'),
                    bodyView: new ActionCreateView({
                        context: context,
                        model: new Action(),
                        project: project,
                        parent: action
                    }),
                    large: true,
                    onChildviewSave: function() {
                        this.disableButtons();
                        this.getOption('bodyView').save()
                            .then(() => {
                                this.hide();
                            })
                            .catch(() => {
                                this.enableButtons();
                            });
                    }
                });
                modal.show();

                this.listenTo(modal, 'done', () => {
                    this.trigger('add:action');
                });
            });
    },

    showImportAction: function() {
        this.getChildView('importFileSelector').show();
    },

    importAction: function(content) {
        ActionRepository.find(this.model).get(this.model.getActionID())
            .then(action => {
                (new ActionImportService(action, content.getLatestVersion()))
                    .import()
                    .then(importAction => {
                        const project = this.model;
                        const importId = importAction['id'];

                        Router.navigateProcessImport(project, action, importId);

                        this.getChildView('importFileSelector').hide();
                    });
            });
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/process/nav/index.js